import React, { useContext } from 'react';
import FormatSelected from '../Pedido/FormatSelected';
import { ArteFinalContext_v2 } from '../../context/ArteFinalContext_v2';

const DropdownOption = ({ isInformational, onChange, options, id }) => {
  const { formatSelected } = useContext(ArteFinalContext_v2);

  const selectedOption = options.find((option) => option.value === formatSelected?.formatoId) || options[0];

  return (
    <div className="custom-select-container">
      <div className="format-selector" id={id}>
        {selectedOption ? (
          <FormatSelected
            isInformational={isInformational}
            selected={true}
            options={options}
            option={selectedOption}
            showIconDropdown={options.length > 1}
            onChange={onChange}
          />
        ) : (
          'Select an option'
        )}
      </div>
    </div>
  );
};

export default DropdownOption;
